import { z } from "zod";

import { imageSchema } from "@/services/cms/cms.schema";

export const bioPropsSchema = z.object({
  heading: z.string().nullable().optional(),
  bios: z.array(
    z.object({
      label: z.string().min(3),
      bio: z.object({
        photo: imageSchema,
        name: z.string().min(3),
        prefix: z.string().nullable(),
        description: z.string().min(3),
      }),
    }),
  ),
});
